import { Link, useParams, useSearchParams } from "react-router-dom";
import apiAgent from "../api/apiAgent";
import { useEffect, useState } from "react";
import { tMsg } from "../components/ToastNotifications";
import { Button } from "../components/Button";
import { Loader } from "../components/Loader";
import { pause } from "../utils";

const ResetMFA = (): JSX.Element => {
  const [searchParams] = useSearchParams();
  const reset_id = searchParams.get("r") || "";
  const [submitting, setSubmitting] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);

  const resetToken = async () => {
    try {
      setSubmitting(true);
      const response = await apiAgent.Auth.resetMFA({ reset_id });
      await pause(1000);
      if (response.status === 200) {
        tMsg.success(`MFA Token successfully reset`);
      } else {
        setError(true);
      }
    } catch (err) {
      setError(true);
      console.log(err);
    } finally {
      setSubmitting(false);
    }
  };

  useEffect(() => {
    resetToken();
  }, []);

  const SubmittedElement = () => (
    <>
      <h1 className="font-bold text-lg">Your Token has been reset</h1>
      <div className="text-sm my-4">Please login again</div>
      <div className="text-primaryColor opacity-80 hover:opacity-100 transition">
        <Link to="/auth">Return to login page</Link>
      </div>
    </>
  );

  return (
    <div className="w-full h-full grid content-center">
      <div className="space-y-4 flex flex-col justify-center">
        <div className="font-medium place-self-center w-64 space-y-4 text-center">
          {submitting ? (
            <>
              <h1 className="font-bold text-lg">Resetting your MFA Token</h1>
              <div className="grid place-items-center">
                <Loader />
              </div>
            </>
          ) : error ? (
            <>
              <h1 className="font-bold text-lg">Error resetting token</h1>
              <div className="text-sm my-4">
                This page has expired, or an error has occured while resetting
                your MFA token.
              </div>
              <div className="text-primaryColor opacity-80 hover:opacity-100 transition">
                <Link to="/auth">Return to login page</Link>
              </div>
            </>
          ) : (
            <SubmittedElement />
          )}
        </div>
      </div>
    </div>
  );
};

export default ResetMFA;
